import { gsap } from 'gsap';

const initFadeInAnimation = () => {
  const fadeElements = document.querySelectorAll('.fade-in');
  fadeElements.forEach((element) => {
    gsap.set(element, { opacity: 0, y: 100, duration: 1 });

    gsap.to(element, {
      opacity: 1,
      y: 0,
      duration: 1,
      scrollTrigger: {
        trigger: element,
        start: 'top 95%',
        end: 'bottom 95%',
        toggleActions: 'play none none reverse'
      }
    });
  });
};

export default initFadeInAnimation;
